import type { TFunction } from 'i18next';
import { DateTime } from 'luxon';

export const formatEventDate = (
  startDateIso: string,
  endDateIso: string,
  t: TFunction<'translation', undefined>,
  locale: string,
): string => {
  const startDate = DateTime.fromISO(startDateIso);
  const endDate = DateTime.fromISO(endDateIso);
  const isSameDay = startDate.hasSame(endDate, 'day');

  return isSameDay
    ? t('formatEventDate.event-from-to-same-day', {
        day: startDate.toLocaleString(
          {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            year: startDate.hasSame(endDate, 'year') ? undefined : 'numeric',
          },
          {
            locale,
          },
        ),
        fromTime: startDate.toLocaleString(DateTime.TIME_SIMPLE, { locale }),
        toTime: endDate.toLocaleString(DateTime.TIME_SIMPLE, { locale }),
      })
    : t('formatEventDate.event-from-to', {
        fromDate: startDate.toLocaleString(DateTime.DATETIME_SHORT, { locale }),
        toDate: endDate.toLocaleString(DateTime.DATETIME_SHORT, { locale }),
      });
};
